import React, { useState,useContext, useEffect } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import '../../pages/Faq/Faqs.css';
import './PlanFeatures.css';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { isTextOnly,isRequired } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "features"

const Features = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [items, setItems] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [popupError, setPopupError] = useState('');
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedGroupArchiveAction, setSelectedGroupArchiveAction] = useState('');
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const navigate = useNavigate();
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Features"] || 0;
  const [exportState, setExportState] = useState({
    isExporting: false,
    error: null
  });
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];

  const fetchFeatures = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}plans/feature/?id=${id}`);
        if (response && response.data) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(true);
        } else {
          console.error("No data found for the selected feature.");
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
        const response = await authenticatedAxios.get(`${baseurl}plans/feature/`, { params });
        setItems(response.data?.data || []);
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching features:', error);
      }
    }
  };
  
  useEffect(() => {
    fetchFeatures();
  }, [refreshKey]);
  
  useEffect(() => {
    fetchFeatures();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption]);

  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}plans/feature/archive/`, {
        id_list: selectedItems,
      });
      if (response.status >= 200 && response.status < 300) {
        fetchFeatures();
        resetCheckboxState();
        closePopups();
      } else {
        console.error('Failed to archive/unarchive selected features.');
      }
    } catch (error) {
      console.error('Error archiving/unarchiving selected items:', error);
    }
  };
  

  const handleAddFeature = async (formValues) => {
    try {
        const response = await authenticatedAxios.post(
            `${baseurl}plans/feature/`, 
            formValues
        );

        if (response.data.response_code === 1) {
          await fetchFeatures();
          closePopups();
        } else {
          setPopupError(response.data.message || 'Something went wrong!');
        }
      } catch (error) {
        setPopupError('Failed to add Feature. Please try again.');
      }
    };


  const handleEditFeature = async (formValues) => {
    if (!selectedItem) {
        console.error('No feature selected for editing.');
        return;
    }

    try {
        const response = await authenticatedAxios.put(
            `${baseurl}plans/feature/?id=${selectedItem.id}`, 
            formValues
        );
        if (response.data.response_code === 1) {
          await fetchFeatures();
          closePopups();
        } else {
          setPopupError(response.data.message || 'Something went wrong!');
        }
      } catch (error) {
        setPopupError('Failed to add Feature. Please try again.');
      }
    };


  const handleArchive = async () => {
    try {
        const response = await authenticatedAxios.get(
            `${baseurl}plans/feature/archive/?id=${selectedItem.id}`
        );
        if (response.status >= 200 && response.status < 300) {
            await fetchFeatures(); 
            closePopups(); 
        } 
    } catch (error) {
        // console.error('Error archiving feature:', error);
    }
  };

  const handleDeleteFeature = async () => {
    try {
        const response = await authenticatedAxios.delete(
            `${baseurl}plans/feature/?id=${selectedItem.id}`
        );
        if (response.status >= 200 && response.status < 300) {
            await fetchFeatures();
            closePopups(); 
        } else {
            console.error('Failed to delete feature:', response.data);
        }
    } catch (error) {
        console.error('Error deleting feature:', error);
    }
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      case 'Bank':
        return 'Bank';
      case 'UPI':
        return 'UPI';
      default:
        return 'newest';

    }
  };


  const handleEditClick = (item) => {
    fetchFeatures(item.id)
  };


  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };
  
  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };


  const handleNewClick = () => {
    // openPopup('Features');
    setSelectedItem(null);
    setIsNewPopupOpen(true);
  };
  

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDeletePopupOpen(false);
    setSelectedItem([]);
    setPopupError('');
  };
  const addPopupFields = [
    { label: 'New Feature', 'name':'name', type: 'large-input', defaultValue: '',validators: [isRequired, isTextOnly] },
    { label: 'Description','name':'description', type: 'text', defaultValue: '',validators: [isRequired]  },
  ];

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? This action cannot be undone.', type: 'text' },
  ];
  const editPopupFields = [
    { label: 'Feature Name','name':'name',  type: 'large-input',validators: [isRequired, isTextOnly], defaultValue: selectedItem?.name, onChange: () => {} },
    { label: 'Description','name':'description',  type: 'text',validators: [isRequired], defaultValue: selectedItem?.description, onChange: () => {} },
  ];
  const handleExportStart = () => {
    setExportState({ isExporting: true, error: null });
  };
  const handleExportComplete = () => {
    setExportState({ isExporting: false, error: null });
    resetCheckboxState();
  };

  const handleExportError = (error) => {
    setExportState({ isExporting: false, error });
  };
  return (
    <div className="whole-container">
      <div className="top-heading">
        <PageHeader pageName="Plans /" nestedpageName="Features"  linkTo="/our-plans" /> 
        <div className="export-container">
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          <ExportLabel
            exportUrl={`${baseurl}plans/feature/export/`}
            selectedIds={selectedItems}
            onExportStart={handleExportStart}
            onExportComplete={handleExportComplete}
            onExportError={handleExportError}
          />
        </div>
      </div>
      <div className="pagename-container">
        <div className="page-name">
          <h1 className="common-text fts-22 ftw-6 blue">Features</h1>
        </div>
        <div className="pagename-right-container">
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term} />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>


      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Feature NAME
              </th>
              <th className='w-65'>Description</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="common-table-tbody">
            {items.length > 0 ? (
              items.map((feature) => (
                <tr key={feature.id} className={feature.is_archived ? 'archived-item' : ''}>
                  <td className='d-flex ai-center'>
                    <div className='d-flex'>
                      <input
                        className="table-selectbox table-child-selectbox"
                        type="checkbox"
                        checked={selectedItems.includes(feature.id)}
                        onChange={() => handleChildCheckboxChange(feature.id)}
                      />
                    </div>
                    <div className='d-flex ai-center mr-30'>
                    {feature.name}
                    </div>
                  </td>
                  <td>
                    <div className='d-flex ai-center mr-30'>
                      {feature.description}
                    </div>
                  </td>
                  <td className="actions special-action" >
                    <EditIcon onClick={() => handleEditClick(feature)} />
                    <ArchiveIcon onClick={() => handleArchiveClick(feature)} isArchived={feature.is_archived} />
                    <DeleteIcon onClick={() => handleDeleteClick(feature)} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">No Features Available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <EditPopup
        isOpen={isEditPopupOpen}
        title="Edit Feature"
        fields={editPopupFields}
        onSave={handleEditFeature}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />

      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />

      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete Feature"
        fields={deletePopupFields}
        onSave={handleDeleteFeature}
        onClose={closePopups}
      />
      <AddPopup
        isOpen={isNewPopupOpen}
        title="Add Feature"
        buttonName='Add Feature'
        fields={addPopupFields}
        onSave={handleAddFeature}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />
    </div>
  );
};

export default Features;